/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { chainCommands as u, exitCode as h, toggleInlineFormat as i, undo as p, redo as l, undoInputRule as f, splitListItem as S, goToNextCell as c } from "@progress/kendo-editor-common";
import { EditorToolsSettings as M } from "./toolsSettings.mjs";
const { bold: b, underline: y, italic: I } = M, s = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : !1, B = (e) => {
  const r = u(h, (t, o) => {
    const d = e && e.types && e.types.hardBreak || "hard_break", m = t.schema.nodes[d];
    return o && o(t.tr.replaceSelectionWith(m.create()).scrollIntoView()), !0;
  }), a = e && e.types && e.types.listItem || "list_item", n = e && e.toolsSettings || {};
  return {
    "Mod-b": (t, o) => i(n.bold || b)(t, o),
    "Mod-i": (t, o) => i(n.italic || I)(t, o),
    "Mod-u": (t, o) => i(n.underline || y)(t, o),
    "Mod-z": p,
    "Shift-Mod-z": l,
    ...s ? {} : { "Mod-y": l },
    Backspace: f,
    "Mod-Enter": r,
    "Shift-Enter": r,
    ...s ? { "Ctrl-Enter": r } : {},
    Enter: (t, o) => S(t.schema.nodes[a])(t, o),
    Tab: c(1),
    "Shift-Tab": c(-1)
  };
};
export {
  B as getShortcuts
};
